import styled from 'styled-components';
import { TextAlignType } from 'shared/types/general';
import { IStylesProps } from './Title.types';

export const Container = styled.h1<IStylesProps>`
    font-weight: 700;
    font-size: ${({ size }) => size ?? '32px'};
    line-height: 1.2;
    text-align: ${({ textAlign }) => textAlign ?? TextAlignType.CENTER};
    color: ${({ color }) => color ?? '#121217'};
    margin: ${({ margin }) => margin ?? 0};
    @media (max-width: 767px) {
        font-size: ${({ size }) => size ?? '26px'};
    }
`;
